import { CommonModule } from '@angular/common';
import { Component, DOCUMENT, OnInit, effect, inject, input, signal } from '@angular/core';
import { PlatformService } from 'src/app/core/services/platform/platform.service';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';

@Component({
  standalone: true,
  selector: 'webstore-razorpay-affordability-widget',
  imports: [CommonModule],
  templateUrl: './razorpay-affordability-widget.component.html',
  styleUrls: ['./razorpay-affordability-widget.component.scss']
})
export class RazorpayAffordabilityWidgetComponent implements OnInit {
  private platformService = inject(PlatformService);
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);
  private document = inject<Document>(DOCUMENT);


  rzpKey = '';
  isBrowser = false;



  readonly sellingPriceInput = input<number>(0);
  private _sellingPrice = signal<number>(0);

  // Computed getter for backward compatibility
  get sellingPrice() {
    return this._sellingPrice();
  }

  constructor() {
    this.isBrowser = this.platformService.isBrowser();

    // Effect to handle sellingPriceInput changes
    effect(() => {
      const sellingPriceValue = this.sellingPriceInput();
      this._sellingPrice.set(sellingPriceValue);
    });
  }

  ngOnInit() {

    this.rzpKey = this.storeConfigurationRepositoryService.razorpayConfiguration()?.merchant_id || ''
    if (this.isBrowser && this.rzpKey) {
      this.loadRazorpayScript().then(() => {
        const RazorpayAffordabilitySuite = (window as any).RazorpayAffordabilitySuite;
        if (RazorpayAffordabilitySuite && this.rzpKey) {
          const amount = (+this.sellingPrice?.toFixed(2)) * 100; //in paise
          const widgetConfig = {
            key: this.rzpKey,
            amount
          };
          const rzpAffordabilitySuite = new RazorpayAffordabilitySuite(widgetConfig);
          rzpAffordabilitySuite.render();
        }
      }).catch(() => { });

    }
  }

  private loadRazorpayScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).RazorpayAffordabilitySuite) {
        resolve(); // Already loaded
        return;
      }
      const script = this.document.createElement('script');
      script.src = 'https://cdn.razorpay.com/widgets/affordability/affordability.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = (error) => reject(new Error('Failed to load Razorpay script'));
      this.document.body.appendChild(script);
    });
  }

}

